<template>
  <div class="vx-row">
    <!-- STEP SETUP -->
    <div class="w-full md:w-1/2 px-4" v-if="form">
      <vx-card class="px-4 py-8">
        <div class="flex gap-4 flex-col ">
        
          <div class="flex gap-4 flex-col">
            <h1>Consulta tu Expediente Online</h1>
            <p>Consulta y recibe al correo de manera gratuita el estado de tu expediente de protección internacional en España de manera rápida online</p>
          </div>
        
          <div class="flex gap-4 flex-col">
            <div class="w-full">
              <vs-input
                v-validate="'required|email'"
                data-vv-validate-on="blur"
                name="email"
                type="email"
                label-placeholder="Email"
                placeholder="Email"
                v-model="email"
                class="w-full pt-1"
              />
              <span class="text-danger text-sm">{{ errors.first('email') }}</span>
            </div>

            <div class="w-full">
              <vs-input
                v-validate="'required'"
                data-vv-validate-on="blur"
                type="nie"
                label-placeholder="NIE"
                placeholder="NIE"
                v-model="nie"
                class="w-full pt-1"
              />
              <span class="text-danger text-sm">{{ errors.first('nie') }}</span>
            </div>
          
            <div class="w-full flex gap-2 py-2 items-center">
              <vs-switch color="primary" v-model="isAutomatic"></vs-switch>
              <label>
                <p>
                  Subscribirse al servicio de notificacion semanal por correo del estado de su expediente de Protección internacional.
                </p>
              </label>
            </div>
          
            <div class="w-full flex gap-2 py-2 items-center">
              <vs-switch color="primary" v-model="isTermsConditionAccepted"></vs-switch>
              <label>
                <a href="https://cohenyaguirre.es/politica-de-privacidad-y-cookies/" target="_blank">
                  Acepto los términos y condiciones
                </a>
              </label>
            </div>
          </div>
        
          <div class="flex gap-4 justify-center">
            <vs-button @click="checkStatus()" :disabled="!validateForm">Consultar mi expediente</vs-button>
          </div>
        </div>
      </vx-card>
      
      <div class="w-full p-4 text-center" v-if="subscribed">
        Deseas darte de baja de nuestro servicio?, <a href="#" @click="dropout">haz click aqui</a>
      </div>
    </div>

    <!-- STEP RESULT -->
    <div class="w-full md:w-1/2 px-4" v-else>
      <vx-card class="px-4 py-8">
        <div class="flex gap-4 flex-col gap-4">

          <div class="flex flex-row gap-4 items-center">
            <feather-icon v-if="resultType === 'success'" icon="CheckCircleIcon" svgClasses="text-success h-8 w-8" />
            <feather-icon v-else-if="resultType === 'danger'" icon="XCircleIcon" svgClasses="text-danger h-8 w-8" />
            <feather-icon v-else icon="AlertCircleIcon" svgClasses="text-warning h-8 w-8" />
            <h2 :class="`text-${resultType}`">Estado: {{result}}</h2>
          </div>

          <div class="flex flex-row gap-8" v-if="document">
            <p><a :href="document" target="_blank"> Descarga el BOE relacionado aqui </a></p>
          </div>

          <div class="flex flex-row gap-8">
            <p><b>Ν.Ι.Ε:</b> {{nie}} </p>
          </div>
          <div class="flex flex-row gap-8">
            <p><b>Ultima Actualización:</b> {{ resultDate }}</p>
          </div>

          <div class="flex flex-col gap-4">
            <p>
              La información que se ofrece en esta página no tiene carácter de notificación.
              <br>
              Los trámites posteriores a la concesión se deben realizar en el Registro Civil.
            </p>
          </div>

          <div class="flex flex-col sm:flex-row gap-2 justify-between">
            <vs-button type="border" @click="form=true">Editar Subscripcion</vs-button>
            <vs-button @click="checkStatus()">Actualizar esta información</vs-button>
          </div>
        </div>
      </vx-card>
      <div class="w-full p-4 text-center" v-if="subscribed">
        Deseas darte de baja de nuestro servicio?, <a href="#" @click="dropout">haz click aqui</a>
      </div>
    </div>

  </div>
</template>
<script>
import axios from '@/axios.js'
export default {
  data () {
    return {
      form: true, 
      subscribed: false,
      document: '',

      nie: '',
      email: '',
      
      isAutomatic: true,
      isTermsConditionAccepted: false,

      result: '',
      resultType: '',
      resultDate: ''
    }
  },
  mounted () {
    axios.get('/subscription-tool').then((response) => {
      if (response.data && response.data.length) {
        response.data.forEach(element => {
          if (element.tool === 'ProteccionInternacional') {
            this.subscribed = true
            this.isAutomatic = true
            this.isTermsConditionAccepted = true
            this.email = element.email
            if (element.data && element.data.length) {
              element.data = JSON.parse(element.data)
              this.nie = element.data.nie ? element.data.nie : ''
            }
          }
        })
      }
    })
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.nie && this.email && this.isTermsConditionAccepted
    }
  },
  methods: {
    dropout () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar Darse de baja',
        text: '¿Está seguro que deseas darte de baja de nuestro servicio de notificacion por email acerca de tu expediente de proteccion internacional?',
        accept: this.dropout_confirm,
        acceptText: 'Darse de baja',
        cancelText: 'Regresar'
      })
    },
    dropout_confirm () {
      this.$vs.loading()
      
      axios.post('/subscription-tool/remove', {tool: 'ProteccionInternacional'}).then((response) => {
        console.log(response)
        this.form = true 

        this.subscribed = false
        this.isAutomatic = false
        this.isTermsConditionAccepted = false
        this.email = ''
        this.nie = ''
        this.birth = ''
        this.number = ''
        this.document = ''

        this.$vs.notify({
          title: 'Te has dado de Baja',
          text: 'Te has dado de baja a nuestro servicio, puedes volver a darte de alta cuando gustes!',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success',
          time: 6000
        })
        this.$vs.loading.close()
      }).catch((error) => {
        console.log(error)
        this.$vs.notify({
          title: 'Hubo un problema',
          text: `${error.response.data && error.response.data.error ? error.response.data.error : error}`,
          iconPack: 'feather',
          icon: 'icon-x-circle',
          color: 'warning',
          time: 6000
        })
        this.$vs.loading.close()
      })
    },
    checkStatus () {
      this.$vs.loading()
      this.document = ''
      const data = {
        tool: 'ProteccionInternacional',
        email: this.email,
        isAutomatic: this.isAutomatic,
        data: {
          nie: this.nie
        }
      }
      axios.post('/subscription-tool', data).then((response) => {
        console.log(response)
        this.form = false 
        this.$vs.notify({
          title: 'Hemos conseguido el siguiente resultado',
          text: 'Este ha sido el ultimo resultado de tu consulta',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success',
          time: 6000
        })
        this.result = response.data && response.data.result ? response.data.result : ''
        this.document = response.data && response.data.document ? response.data.document : ''
        this.resultType = response.data && response.data.resultType ? response.data.resultType : ''
        this.resultDate = response.data && response.data.resultDate ? response.data.resultDate : ''
        
        this.$vs.loading.close()
      }).catch((error) => {
        console.log(error)
        this.$vs.notify({
          title: 'Hubo un problema',
          text: `${error.response.data && error.response.data.error ? error.response.data.error : error}`,
          iconPack: 'feather',
          icon: 'icon-x-circle',
          color: 'warning',
          time: 6000
        })
        this.$vs.loading.close()
      })
    }
  }
}
</script>